// Read-only view model for a `videocallRequests` document.
//
// The website only ever CREATES videocall requests; everything after creation
// (status lifecycle, assigned architect, meeting details) is written by the
// platform. This class wraps a fetched doc for the user's read-only
// "videochiamate" area — no toMap()/write helpers on purpose.
const STATUS_LABELS = {
  'da-prenotare': 'Da prenotare',
  contattato: 'Contattato',
  'da-ricontattare': 'Da ricontattare',
  prenotata: 'Prenotata',
  completata: 'Completata',
  annullata: 'Annullata',
  'no-show': 'Non presentato',
};

export default class VideocallRequest {
  constructor(firebaseId, data = {}) {
    this.firebaseId = firebaseId || '';

    // origin / identity
    this.source = data.source;
    this.code = data.code;

    // client info (set by the website)
    this.clientUserId = data.clientUserId;
    this.clientName = data.clientName;
    this.clientEmail = data.clientEmail;
    this.clientPhone = data.clientPhone;

    // property / advertisement
    this.newarcHomeId = data.newarcHomeId;
    this.adCode = data.adCode;
    this.adAddress = data.adAddress;
    this.adUrl = data.adUrl;
    this.propertyType = data.propertyType;
    this.propertyMq = data.propertyMq;
    this.propertyLocals = data.propertyLocals;

    // client preferences
    this.preferredDays = data.preferredDays;
    this.preferredTimeSlots = data.preferredTimeSlots;
    this.objectives = data.objectives;
    this.notes = data.notes;
    this.generalPropertyLink = data.generalPropertyLink;

    // lifecycle (platform-written)
    this.requestStatus = data.requestStatus;

    // meeting (platform-written)
    this.appointmentAt = data.appointmentAt;
    this.durationMin = data.durationMin;
    this.meetingTool = data.meetingTool;
    this.meetingLink = data.meetingLink;

    // assigned architect (platform-written; phone lives on the user profile)
    this.architectId = data.architectId;
    this.architectName = data.architectName;
    this.architectEmail = data.architectEmail;

    // bookkeeping
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.isArchived = data.isArchived;
  }

  statusLabel() {
    if (!this.requestStatus) return '';
    return STATUS_LABELS[this.requestStatus] || this.requestStatus;
  }

  hasArchitect() {
    return !!(this.architectName && this.architectName.length);
  }

  hasMeeting() {
    return !!this.appointmentAt;
  }

  displayAddress() {
    return this.adAddress ? this.adAddress : 'Consulenza generale';
  }
}
